import { Fragment, type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { observable, runInAction } from 'mobx'
import { nanoid } from 'nanoid'

type DialogStackEntry = {
    key: string
    render: (context: { close: (result?: any) => void }) => ReactNode
    resolve: (result?: any) => void
}

const dialogStack = observable<DialogStackEntry>([])

export const showDialog = <Result,>(
    render: (context: { close: (result?: Result) => void }) => ReactNode
): Promise<Result | undefined> => {
    return new Promise<Result | undefined>((resolve) => {
        runInAction(() => {
            dialogStack.push({
                key: nanoid(),
                render,
                resolve,
            })
        })
    })
}

const closeDialog = (key: string, result?: any) => {
    const entry = dialogStack.find((dialog) => dialog.key === key)

    if (!entry) {
        return
    }

    runInAction(() => {
        dialogStack.replace(dialogStack.filter((dialog) => dialog.key !== key))
    })

    entry.resolve(result)
}

export const DialogStack = observer(() => {
    return dialogStack.map((dialog) => (
        <Fragment key={dialog.key}>{dialog.render({ close: (result) => closeDialog(dialog.key, result) })}</Fragment>
    ))
})
